import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import Games from "@/pages/Games";

export const Route = createFileRoute("/_app/games/")({
  component: () => (
    <PageGate pageKey="games"><Games /></PageGate>
  ),
});
